module.exports = __webpack_public_path__ + "static/media/arei.f98379c3.png";